import { z } from "zod";
export const RuleField = z.enum(["age", "household_size", "household_income", "has_child_under", "pregnant", "disabled", "veteran", "senior", "employment_status", "state"]);
export const RuleOperator = z.enum([">=", "<=", "=", "!=", "in", "%FPL<="]);
export const RuleKind = z.enum(["required", "indicative"]);
/** Plain object schema, so .pick/.omit keep working (a refined schema is a ZodEffects and has neither). */
export const RuleInputBase = z.object({
    programId: z.string().min(1), stateCode: z.string().length(2).nullable(),
    field: RuleField, operator: RuleOperator, value: z.string().trim().min(1).max(200),
    unit: z.string().max(40).nullable(), sourceId: z.string().nullable(), status: z.enum(["verified", "pending"]),
    kind: RuleKind.default("required"), note: z.string().max(400).nullable().default(null),
});
/** A required rule is a hard gate and carries no note; only indicative rules may. */
export function requiredHasNoNote(r, ctx) {
    if (r.kind === "required" && r.note !== null)
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["note"], message: "A required rule cannot have a note" });
}
/** Indicative wording ("usual limit") only fits income rules for now; the engine itself stays generic. */
export function indicativeOnlyIncome(r, ctx) {
    if (r.kind === "indicative" && r.field !== "household_income")
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["field"], message: "indicative rules are only supported for household_income" });
}
export const RuleInput = RuleInputBase.superRefine((r, ctx) => { requiredHasNoNote(r, ctx); indicativeOnlyIncome(r, ctx); });
export const IncomeTableRowInput = z.object({
    kind: z.enum(["fpl", "state_limit", "ami"]), year: z.number().int().min(1990).max(2100),
    stateCode: z.string().length(2).nullable(), householdSize: z.number().int().min(1).max(30),
    amount: z.number().min(0), period: z.enum(["monthly", "yearly"]), sourceId: z.string().nullable(),
});
export const MatchInput = z.object({
    state: z.string().length(2), zip: z.string().regex(/^\d{5}$/).optional(),
    householdSize: z.number().int().min(1).max(30).optional(),
    income: z.number().min(0).max(10_000_000).optional(),
    incomePeriod: z.enum(["monthly", "yearly"]).optional(),
    employment: z.enum(["employed", "unemployed", "self_employed", "retired", "unable_to_work"]).optional(),
    ageRange: z.enum(["under18", "18_24", "25_49", "50_64", "65_plus"]).optional(),
    childrenUnder: z.array(z.number().int().min(0).max(18)).max(20).optional(),
    pregnant: z.boolean().optional(), disabled: z.boolean().optional(), veteran: z.boolean().optional(), senior: z.boolean().optional(),
    problemId: z.string().optional(), categories: z.array(z.string()).max(50).optional(),
    urgency: z.enum(["low", "normal", "high", "emergency"]),
});
export const MatchStatus = z.enum(["potentially_eligible", "insufficient_information", "unlikely_eligible"]);
export const MATCH_DISCLAIMER = "Not a determination. The agency decides eligibility.";
//# sourceMappingURL=matching.js.map